module.exports = __webpack_public_path__ + "img/Qapaq.051c00e9.svg";